module.exports = __webpack_public_path__ + "static/media/appstore.30fdca71.png";